<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";

Vue.component("v-select", vSelect);

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Información del producto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      datos: [],
      apiUrl: process.env.VUE_APP_URL,
      historialpre: [],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      fields: [
        {
          name: "proveedore.company_proveedor",
          sortField: "proveedore.company_proveedor",
          title: "Compañia Proveedor",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "proveedor",
          sortField: "proveedor",
          title: "Inmediato del Proveedor",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "20%",
        },
        {
          name: "preciocompraanterior",
          sortField: "preciocompraanterior",
          title: "Precio Compra Anterior",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "preciocompranuevo",
          sortField: "preciocompranuevo",
          title: "Precio Compra Nuevo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "precioventaanterior",
          sortField: "precioventaanterior",
          title: "Precio Venta Anterior",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "precioventanuevo",
          sortField: "precioventanuevo",
          title: "Precio Venta Nuevo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "15%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "5%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formget: {
        nombrep: "",
        companiap: "",
        nit: "C/F",
        direccionp: "",
        statep: true,
      },

      updating: false,
      title: "Información",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Información",
          active: true,
        },
      ],

      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.historialpreciost();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    //Detalle Historial
    historialpreciost() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/historial_precios?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.historialpre = response.data.data;
          // console.log(this.historialpre)
          /*  this.formget.nombre=response.data.cabecera.nombre_auto;
       this.formget.state=response.data.cabecera.estado_auto; */
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div class="text-center">
                    <div class="mb-4">
                      <a href="#" class="badge bg-light font-size-12">
                        <i
                          class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                        ></i>
                        Información del Producto
                      </a>
                    </div>

                    <h4>Historial Precio</h4>
                  </div>

                  <hr />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-12">
                        <div>
                          <router-link
                            :to="{
                              name: 'productos',
                            }"
                          >
                            <b-button
                              variant="outline-primary"
                              type="button"
                              class="btn btn-rounded mb-2 me-2"
                            >
                              <i class="mdi mdi-arrow-collapse-left"></i>
                              Regresar
                            </b-button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de precio de compra y venta.</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="historialpre"
              >
                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_historial_p == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="preciocompraanterior" slot-scope="props">
                  {{ money(props.rowData.precio_compra_anterior) }}
                </div>
                <div slot="proveedor" slot-scope="props">
                  {{ props.rowData.proveedore.persona.nombre_persona }}
                  {{ props.rowData.proveedore.persona.apellido_persona }}
                </div>
                <div slot="preciocompranuevo" slot-scope="props">
                  {{ money(props.rowData.precio_compra_nuevo) }}
                </div>
                <div slot="precioventaanterior" slot-scope="props">
                  {{ money(props.rowData.precio_venta_anterior) }}
                </div>
                <div slot="precioventanuevo" slot-scope="props">
                  {{ money(props.rowData.precio_venta_nuevo) }}
                </div>
              </vuetable>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
